var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoInBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.4,
    height: 21.4,
    viewBox: "0 0 21.4 21.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_info_in_box",
    "data-name": "icona info in box",
    transform: "translate(-2.3 -2.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_176",
    "data-name": "Tracciato 176",
    d: "M23,13A10,10,0,1,1,13,3,10,10,0,0,1,23,13Z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_177",
    "data-name": "Tracciato 177",
    d: "M18,22V18",
    transform: "translate(-5 -5)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_178",
    "data-name": "Tracciato 178",
    d: "M18,12h0",
    transform: "translate(-5 -3)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoInBox);
export default __webpack_public_path__ + "static/media/info_in_box.36b8255e4272e85115a1f0d1b1ce4257.svg";
export { ForwardRef as ReactComponent };